export interface Service {
  number: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  features: string[];
}

interface ServiceCardProps {
  service: Service;
}

export default function ServiceCard({ service }: ServiceCardProps) {
  return (
    <article className="group flex flex-col h-full rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-500 hover:-translate-y-2 hover:border-primary-200">
      <div className="relative w-full h-52 md:h-56 overflow-hidden">
        <img
          src={service.image}
          alt={service.imageAlt}
          title={service.imageAlt}
          className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent"></div>
        <span className="absolute bottom-4 left-5 font-heading text-4xl md:text-5xl font-bold text-background-50/90">
          {service.number}
        </span>
      </div>

      <div className="flex flex-col flex-1 p-6 md:p-7">
        <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
          {service.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed mb-5">{service.description}</p>

        <ul className="flex flex-col gap-2 mt-auto">
          {service.features.map((feature) => (
            <li key={feature} className="flex items-center gap-2.5 text-sm text-foreground-700">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
}